// extracted by mini-css-extract-plugin
export default {"list":"questions_section-module___list___a04f558b"};